import { toSafeAmount } from '@/shared/utils/apiResponseHelpers';
import { getDefaultDateRange } from '@/shared/utils/dateDefaultUtils';
import type { DeliveryHistoryDetailFilters, DeliveryHistoryDetailRow } from '../types/deliveryHistoryDetail.types';
import type { DeliveryHistoryDetailRawItem } from '../types/deliveryHistoryDetail.api.types';

const BASE_FILTERS: DeliveryHistoryDetailFilters = {
    startDate: '',
    endDate: '',
    suppId: '',
    suppName: '',
    riderId: '',
};

export const getDefaultFilters = (): DeliveryHistoryDetailFilters => {
    const { startDate, endDate } = getDefaultDateRange();
    return { ...BASE_FILTERS, startDate, endDate };
};

export const normalizeDetailRow = (item: DeliveryHistoryDetailRawItem): DeliveryHistoryDetailRow => ({
    suppId: item.suppId ?? '',
    riderId: item.riderId ?? '',
    suppName: item.suppName,
    riderName: item.riderName,
    deliveryDate: item.deliveryDate ?? '',
    deliveryNo: item.deliveryNo ?? '',
    deliveryStatus: item.deliveryStatus ?? '',
    serviceType: item.serviceType ?? '',
    deliveryType: item.deliveryType ?? '',
    deliveryMethod: item.deliveryMethod ?? '',
    shopNo: item.shopNo ?? '',
    shopName: item.shopName ?? '',
    goodsAmt: toSafeAmount(item.goodsAmt),
    pickupAddr: item.pickupAddr ?? '',
    deliveryAddr: item.deliveryAddr ?? '',
    orderTime: item.orderTime ?? '',
    assingTime: item.assingTime ?? '',
    shopArriTime: item.shopArriTime ?? '',
    pickupTime: item.pickupTime ?? '',
    deliveryTime: item.deliveryTime ?? '',
    distance: toSafeAmount(item.distance),
    pickupPlace: item.pickupPlace ?? '',
    baseAmt: toSafeAmount(item.baseAmt),
    weatherAmt: toSafeAmount(item.weatherAmt),
    addAmt: toSafeAmount(item.addAmt),
    peakTimeAmt: toSafeAmount(item.peakTimeAmt),
    locationAmt: toSafeAmount(item.locationAmt),
    deliveryAmt: toSafeAmount(item.deliveryAmt),
    riderFaultYn: item.riderFaultYn ?? '',
    addAmtReason: item.addAmtReason ?? '',
});
